import { createFileRoute } from "@tanstack/react-router";
import { ServicePage, buildServiceMeta } from "@/components/ServicePage";
import { commercialContent } from "@/data/serviceContent";

const slug = "awning-cleaning";
const c = commercialContent[slug];

export const Route = createFileRoute("/commercial/awning-cleaning")({
  head: () => buildServiceMeta({
    title: c.title,
    description: c.intro[0].slice(0, 155),
    path: "/commercial/awning-cleaning",
  }),
  component: () => <ServicePage category="commercial" slug={slug} {...c} />,
});
